<template>
     <ul>
        <li
            :key="index"
            v-for="(item, index) in list"
            data-text
            class="vs-component"
        >
            <div v-if="Array.isArray(item.value)">
				<div
					:class="{'check-disabled': isAllDisabled(item.value) || maxChecked(item.value)}"
					@click="toggleAllCheckbox($event, item.value)">
					<vs-checkbox
						class="mb-3"
						:disabled="isAllDisabled(item.value) || maxChecked(item.value)"
						:value="isAllChecked(item.value)"
						:id="'parent' + parent + removeSpecialCharacter(removeWhiteSpace(item.key + index))"
						>
						{{item.key}}
					</vs-checkbox>
				</div>
                <ld-select-checkbox-items
                    :list.sync="item.value"
                    :select="select"
                    :model.sync="model"
                    :sub="true"
                    :parent="parent + removeSpecialCharacter(removeWhiteSpace(item.key + index))"
                    :minChecked="minChecked"
                    class="subnivel"/>
            </div>

            <div
				:class="{'check-disabled': item.disabled || maxChecked(item.value)}"
				@click="setterSubnivel($event, item.value)"
				v-else>
                <vs-checkbox
                    class="mb-3"
                    :value="isChecked(item.value)"
                    :id="'check' + removeSpecialCharacter(item.value)"
                    :disabled="item.disabled || maxChecked(item.value)"
                >
                    {{item.key}}
                </vs-checkbox>
            </div>
        </li>
    </ul>
</template>

<script>
import StringHelper from '../../helpers/StringHelper';

export default {
    name: "LdSelectCheckboxItems",
    props: {
        minChecked: Number,
        model: {
            required: false
        },
        list: Array,
        sub: Boolean,
        parent: {
            type: String,
            default: ''
        },
        select: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            checkbox: null,
        };
    },
    methods: {
		removeWhiteSpace(string) {
			return StringHelper.removeWhiteSpace(string);
		},
        removeSpecialCharacter(value) {
            if (typeof value != 'string') {
                value = `${value}`;
            }

            return value.replace(/[^\w]/g, '');
        },
        setterSubnivel(event, data, isChecked) {

            if (Array.isArray(this.model)) {

                if (isChecked || (event && event.target && event.target.checked)) {
                    if (!this.model.includes(data)) {
                        this.model.push(data);
                    }
                    this.select({
                        data: this.model,
                        value: data,
                        selected: true
                    });
                } else {
                    this.model.forEach((item, index) => {
                        if (item === data) {
                            this.model.splice(index, 1);
                        }
                    });
                    this.select({
                        data: this.model,
                        value: data,
                        selected: false
                    });
                }

            }

            this.checkParent();
        },
        checkParent() {
            if (this.parent) {

                const $checkboxParent = this.$parent.$el.querySelector(`#parent${this.parent}`);

                if ($checkboxParent) {
                    if (this.list.length === this.model.length) {
                        if (!$checkboxParent.checked) {
                            $checkboxParent.checked = true;
                        }
                    } else {
                        if ($checkboxParent.checked) {
                            $checkboxParent.checked = false;
                        }
                    }
                }
            }
        },
        toggleAllCheckbox(event, data) {

            const target = event.target;

            if (target) {

                data.forEach((item, index) => {

                    if (Array.isArray(item.value)) {
                        this.toggleAllCheckbox(event, item.value);
                    } else {
                        if (!item.disabled) {
                            let $input = this.$el.querySelector(`#check${this.removeSpecialCharacter(item.value)}`);

                            if ($input) {
                                if (target.checked && !$input.checked) {
                                    $input.checked = true;
                                    this.setterSubnivel(null, item.value, true);

                                } else if (!target.checked && $input.checked) {

                                    const minChecked = this.minChecked > 0 ? this.minChecked - 1 : this.minChecked;

                                    if (this.model.length > minChecked) {
                                        if (minChecked === 0 || index !== 0) {
                                            $input.checked = false;
                                            this.setterSubnivel(null, item.value, false);
                                        }
                                    }
                                }
                            }
                        }
                    }

                });
            }
        },
        isAllChecked(list) {
            return list.every(item => {
                if (Array.isArray(item.value)) {
                    return this.isAllChecked(item.value);
                } else {
                    return this.model.includes(item.value);
                }
            });
        },
        isAllDisabled(list) {
            return !list.some(item => {
                if (Array.isArray(item.value)) {
                    return !this.isAllDisabled(item.value)
                } else {
                    return !item.disabled;
                }
            });
        },
        isChecked(item) {
            return this.model.includes(item);
        },
        maxChecked(item) {
            const isMax = this.model.length < this.minChecked;

            if (Array.isArray(item)) {
                const isTotal = this.model.length === item.length;

                return isMax && isTotal;
            }

            const isChecked = this.model.includes(item);

            return isMax && isChecked;
        }
    },
};
</script>

<style lang="scss">

.ld-select-checkbox {

    .vs-checkbox {
        min-height: 20px;
        min-width: 20px;
    }

    ul {
        position: relative;

        .subnivel {
            padding-left: 15px;
            max-height: 100% !important;
        }
	}

	.check-disabled {
		pointer-events: none;
	}

    .vs-select--item {
        min-height: 28px;
        font-family: 'Montserrat', sans-serif;
    }
}
</style>
